var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340-380h40v-120h180v71.54L651.54-520 560-612.31V-540H372.31q-13.73 0-23.02 9.2T340-508v128Zm140.15 249.23q-12.07 0-23.85-4.85-11.78-4.84-21.53-14.53L150.15-434.77q-9.69-9.66-14.53-21.33-4.85-11.67-4.85-23.75 0-12.07 4.85-23.85 4.84-11.78 14.53-21.53l284.62-284.62q9.66-9.69 21.33-14.53 11.67-4.85 23.75-4.85 12.07 0 23.85 4.85 11.78 4.84 21.53 14.53l284.62 284.62q9.69 9.66 14.53 21.33 4.85 11.67 4.85 23.75 0 12.07-4.85 23.85-4.84 11.78-14.53 21.53L525.23-150.15q-9.66 9.69-21.33 14.53-11.67 4.85-23.75 4.85ZM320-320l143.08 143.08Q470-170 480-170q10 0 16.92-6.92l286.16-286.16Q790-470 790-480q0-10-6.92-16.92L496.92-783.08Q490-790 480-790q-10 0-16.92 6.92L176.92-496.92Q170-490 170-480q0 10 6.92 16.92L320-320Zm160-160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLocation);
export default __webpack_public_path__ + "static/media/change-location.4f6d5ab74e9d32faf7df962e62cb1521.svg";
export { ForwardRef as ReactComponent };